import { render, staticRenderFns } from "./ModalPaymentError.vue?vue&type=template&id=b2351ff0&scoped=true"
import script from "./ModalPaymentError.vue?vue&type=script&lang=js"
export * from "./ModalPaymentError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2351ff0",
  null
  
)

export default component.exports